// extracted by mini-css-extract-plugin
export default {"secondaryColor":"ComplexPageHeaderTitle_secondaryColor__GcKDK","bold":"ComplexPageHeaderTitle_bold__Bf-AT"};